import React from 'react';
type Tone = 'brand' | 'warn' | 'danger' | 'ok' | 'neutral';
const FILL: Record<Tone, string> = {
  brand: 'bg-brand-700',
  warn: 'bg-warn-700',
  danger: 'bg-danger-700',
  ok: 'bg-ok-700',
  neutral: 'bg-ink-subtle'
};
interface MeterProps {
  value: number;
  tone?: Tone;
  label?: string;
  trailing?: string;
  height?: 'thin' | 'regular';
}
export function Meter({
  value,
  tone = 'brand',
  label,
  trailing,
  height = 'regular'
}: MeterProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return <div data-id="element-5365" data-mp="1789z8m4pwfmu">
      {(label || trailing) && <div className="mb-1.5 flex items-baseline justify-between gap-3" data-id="element-5366" data-mp="12arw5cddsumr">
          {label && <span className="text-body-sm text-ink-muted" data-id="element-5367" data-mp="12cl6p2r47z01">{label}</span>}
          {trailing && <span className="cz-num text-body font-semibold text-ink" data-id="element-5368" data-mp="yb9eqqkrr1oo">{trailing}</span>}
        </div>}
      <div className={`w-full overflow-hidden rounded-full bg-line ${height === 'thin' ? 'h-1.5' : 'h-2.5'}`} role="progressbar" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={100} aria-label={label} data-id="element-5369" data-mp="2wmosnjqokqoo">
        <div className={`h-full rounded-full ${FILL[tone]}`} style={{
        width: `${clamped}%`
      }} data-id="element-5370" data-mp="2dpm7uv4dk743" />
      </div>
    </div>;
}